import React from 'react';
import PropTypes from 'prop-types';

import track from 'scripts/presentation/components/lib/track';

export default function BackButton({ count, isVisible, onNavigateBack, previousPath }) {
  if (!isVisible) {
    return null;
  }

  // TODO: make this more resilient. I'm pretty sure this logic belongs in the business layer of whatever `onNavigateBack` does
  let handleOnClick = previousPath === 'Home' ? track.click('breadcrumb-home', onNavigateBack) : onNavigateBack;

  return (
    <div className="navigation-back">
      <div className="navigation-backLink" data-aid="navigateBack" href="#" onClick={handleOnClick}>
        <span className="navigation-backIcon" />
        <span>{previousPath}</span>
      </div>
    </div>
  );
}

BackButton.propTypes = {
  count: PropTypes.number,
  isVisible: PropTypes.bool,
  onNavigateBack: PropTypes.func.isRequired,
  previousPath: PropTypes.string.isRequired,
};
